import {Base} from "@/api/Base"

export class EmployeeReinstated extends Base {
    path = "employee/reinstated"
}